import { RouterProvider } from 'react-router-dom'
import { router } from './app/routes/routes'
import './App.css'
import { useInputMethodDetection } from 'optimized-react-component-library-xyz123'

function App() {
    useInputMethodDetection()

    return <RouterProvider router={router} />
}

export default App
